import { useDeviationQuery } from './useDeviationQuery';
import { useDeviationSubscription } from '../../../../../hooks/useDeviationSubscription';
import { useWeightUnit } from '../../../../../hooks/useGetMetric';
import { useEffect } from 'react';
export const useDashboardDeviationSubscription = (id, widgetType) => {
    const { refetch, data, isLoading } = useDeviationQuery(id, widgetType);
    const weightUnit = useWeightUnit();
    useEffect(() => {
        refetch();
    }, [weightUnit]);
    useDeviationSubscription(widgetType, refetch);
    return { data, isLoading };
};
//# sourceMappingURL=useDashboardDeviationSubscription.js.map